import React, { memo } from "react";
import "./GifStatsItem.scss";

interface IGifStatsItem {
  icon: React.ReactNode;
  label: string;
}

export const GifStatsItem = memo(({ icon, label }: IGifStatsItem) => {
  return (
    <div className="gifStatsItem">
      {icon}
      <span className="statsLabel">{label}</span>
    </div>
  );
});
